<template>
  <div class="login-page-frame">
    <header class="login-brand">
      <span class="login-brand__name">商译</span>
      <span class="login-brand__divider" aria-hidden="true"></span>
      <span class="login-brand__description">全渠道商业服务</span>
    </header>

    <main class="login-main"><slot></slot></main>

    <footer class="login-footer">
      <p class="login-footer__line">
        <span>成都盛夏光年数字科技有限公司 版权所有 © 2019-{{ copyrightYear }}</span>
        <span class="login-footer__divider" aria-hidden="true">|</span>
        <span>备案号：<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">蜀ICP备2024045106号</a></span>
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'LoginPageFrame',
  data() {
    return { copyrightYear: new Date().getFullYear() }
  }
}
</script>

<style lang="less" scoped>
.login-page-frame {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  color: #202c40;
  background-color: #fff;
  background-image: linear-gradient(rgba(255, 255, 255, .78), rgba(255, 255, 255, .78)), url('../../assets/login/commerce-data-white.webp');
  background-position: center;
  background-size: cover, contain;
  background-repeat: no-repeat;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}
.login-brand {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 32px 48px;
  flex: none;
  &__name { color: #0867ee; font-size: 28px; font-weight: 700; letter-spacing: 2px; line-height: 36px; }
  &__divider { width: 1px; height: 22px; background: #d5e1f1; }
  &__description { color: #64758b; font-size: 14px; letter-spacing: 1px; }
}
.login-main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 24px 48px;
}
.login-footer {
  flex: none;
  padding: 16px 24px 22px;
  text-align: center;
  color: #a7b4c6;
  font-size: 12px;
  line-height: 20px;
  &__line { display: flex; flex-wrap: wrap; align-items: center; justify-content: center; column-gap: 8px; margin: 0; }
  a { color: inherit; text-decoration: none; }
  a:hover { color: #006aff; }
}
@media (min-width: 681px) and (max-height: 800px) {
  .login-brand { padding-top: 20px; padding-bottom: 20px; }
  .login-main { padding-top: 12px; padding-bottom: 24px; }
  .login-footer { padding-top: 8px; padding-bottom: 12px; }
}
@media (max-width: 960px) {
  .login-brand { padding: 24px 32px; }
}
@media (max-width: 680px) {
  .login-brand { padding: 24px; gap: 12px; }
  .login-brand__name { font-size: 24px; }
  .login-brand__description { font-size: 12px; letter-spacing: 0; }
  .login-main { padding: 20px 20px 36px; }
  .login-footer { font-size: 11px; padding: 12px 20px 20px; }
  .login-footer__divider { display: none; }
}
@media (max-width: 360px) {
  .login-brand { padding: 20px; }
  .login-main { padding: 16px; }
}
</style>
